export const specData = {
  unitData: {
    specs: {
      value: {
        SpecData: [
          {
            specsType: ["Bathroom", "Bedroom", "Living Room"],
            specs: [
              {
                style1: {
                  title: "Bathroom Style 1",
                  body: "It is elegant and spacious. You may like it, you may not, but whatever.",
                  list: {
                    feature1: "Modern fixtures",
                    feature2: "Spacious layout",
                    feature3: "Natural lighting",
                  },
                },
                style2: {
                  title: "Bathroom Style 2",
                  body: "Style 2 for the bathroom offers a sleek, minimalist design.",
                  list: {
                    feature1: "Minimalist fixtures",
                    feature2: "Neutral colors",
                    feature3: "Efficient storage",
                  },
                },
              },
              {
                style1: {
                  title: "Bedroom Style 1",
                  body: "Style 1 for the bedroom emphasizes comfort with a cozy and inviting feel.",
                  list: {
                    feature1: "Plush bedding",
                    feature2: "Soft lighting",
                    feature3: "Warm tones",
                  },
                },
                style2: {
                  title: "Bedroom Style 2",
                  body: "Style 2 for the bedroom is modern and clean with neutral tones and simple decor.",
                  list: {
                    feature1: "Neutral tones",
                    feature2: "Minimalist furniture",
                    feature3: "Open space",
                  },
                },
              },
              {
                style1: {
                  title: "Living Room Style 1",
                  body: "Style 1 for the Living Room emphasizes comfort with a cozy and inviting feel.",
                  list: {
                    feature1: "Plush bedding",
                    feature2: "Soft lighting",
                    feature3: "Warm tones",
                  },
                },
                style2: {
                  title: "Living Room Style 2",
                  body: "Style 2 for the Living Room is modern and clean with neutral tones and simple decor.",
                  list: {
                    feature1: "Neutral tones",
                    feature2: "Minimalist furniture",
                    feature3: "Open space",
                  },
                },
              },
            ],
          },
        ],
      },
    },
  },
}

export default specData
